<script setup>
    import { router, useForm } from '@inertiajs/vue3';
    import multiselect from '@vueform/multiselect';
    import { watch } from "vue";
    import { ref } from "vue";
    import JetButton from '@/Jetstream/Button.vue';

    const programme = router.page.props.ziggy.programme;
    const organisation = router.page.props.ziggy.organisation;
    const urlNamePrefix = organisation ? "gi." : "";

    const props = defineProps({
        toolkitFilters: Object
    });

    const filterDirection = [{'order':'asc', 'name':'Ascending'},{'order':'desc', 'name':'Descending'}];
    //const filterOptions = [{'sortBy':'reference', 'name':'Action reference'},{'sortBy':'points', 'name':'Number of points'},{'sortBy':'status', 'name':'Status'},{'sortBy':'favourites', 'name':'Favourites'}];
    const filterOptions = [{'sortBy':'reference', 'name':'Action reference'},{'sortBy':'points', 'name':'Number of points'}];
</script>

<template>

    <div class="action-filter form-control basis-full md:basis-1/4 mb-1">
        <label class="typo__label sr-only">{{ $t('toolkit.sort.sort_by_filter') }}</label>

        <multiselect
            id="sortBy"
            v-model="toolkitFilters.orderBy.order"
            :options="filterOptions"
            :searchable="false"
            :placeholder="$t('toolkit.sort.sort_by_filter')"
            valueProp="sortBy"
            label="name"
            class="md:mr-5 w-full border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md"
            >
        </multiselect>
    </div>

    <div class="sort-filter-container basis-full md:basis-3/4 md:flex">

        <div class="form-control basis-full md:basis-1/3">
            <label class="typo__label sr-only">{{ $t('toolkit.sort.sort_direction') }}</label>
            <multiselect
              id="SortDirection"
              v-model="toolkitFilters.orderBy.orderDirection"
              :options="filterDirection"
              :searchable="false"
              :placeholder="$t('toolkit.sort.sort_direction')"
              valueProp="order"
              :canClear="false"
              :canDeselect="false"
              label="name"
              class="md:mr-5 w-full border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md"
              >
            </multiselect>

        </div>

        <!-- <JetButton
            type="button"
            class="block btn btn-toolkit-primary justify-center basis-full md:basis-1/2"
        >
        Apply
        </JetButton> -->
    </div>
</template>
